import {
  PROCEDURE_CREATED_FROM,
  PROCEDURE_TYPE,
  useProcedureCreateUpdateMutation,
} from "../../../../../../../../api/procedure/useProcedureCreateUpdateMutation";
import { useCurrentUserQuery } from "../../../../../../../../api/queries/useUserQuery";
import { history } from "../../../../../../../../history";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../../../utilities/api";
import { getHealthPathParams } from "../../../HealthCreateEdit.utils";

export function useSubmit() {
  const { tCommon } = useAppTranslation.Common();
  const { tClients } = useAppTranslation.Clients();
  const { procedureId, clientId } = getHealthPathParams();
  const { data: user } = useCurrentUserQuery();

  const createMutation = useProcedureCreateUpdateMutation({
    onError: (e) => {
      const error = extractApiError(e);
      uiNotification.error(
        tClients(
          `createEditHealthProcedure.apiError.${error}`,
          tCommon("error.createProcedure"),
        ),
      );
    },
    onSuccess: (res) => {
      const procedureId = res?.data?.data?.id;
      const patientId = res?.data?.data?.patient_id;
      uiNotification.success(tCommon("success.createProcedure"));

      if (procedureId && patientId) {
        history.push(`/clients/profile/${patientId}/0/true/${procedureId}`);
      } else {
        history.goBack();
      }
    },
  });

  const initiate = async (form) => {
    return createMutation.mutateAsync({
      id: procedureId,
      patientId: clientId,
      procedureType: PROCEDURE_TYPE.health,
      procedureName: form.chiefComplaint,
      notes: form.notes,
      clinicId: user.clinicId,
      providerId: user.id,
      procedureDate: new Date(),
      createdFrom: PROCEDURE_CREATED_FROM.ePrescribe,
    });
  };

  return {
    initiate,
    isLoading: createMutation.isLoading,
  };
}
